import {
  SET_USER,
  SET_IS_AUTHENTICATED,
} from './types';


export default {
  [SET_USER](state: { user: { privileges: any; }; }, user: any) {
    state.user = user;
    if (typeof state.user.privileges === 'object') {
      state.user.privileges = Object.values(state.user.privileges);
    }
  },

  [SET_IS_AUTHENTICATED](state: { isAuthenticated: boolean; }, isAuthenticated: boolean) {
    state.isAuthenticated = isAuthenticated;
  },
};
